<template>
  <v-container class="fill-height pa-0 white">
    <MobileTopPart
      :style="showingMobileFullImages ? 'display:none;' : ''"
    />
    <ObjectImagesFullMobile
      v-if="showingMobileFullImages"
      :images="selectedObject.objectImages"
      :compact="true"
      :img-folder="'objectImages/large'"
    />
    <v-row :style="showingMobileFullImages ? 'display:none;' : ''">
      <v-col
        :class="isMobileView ? 'pt-0' : ''"
      >
        <v-container class="pa-0" fluid>
          <v-row>
            <v-col :class="isMobileView ? 'pt-0' : ''">
              <ObjectInfo
                v-if="!showBookNowForm && selectedObject && selectedObject._id"
                :object="selectedObject"
              />
              <MyLoader v-else-if="!showBookNowForm" :spacing="150" />
              <BookingForm
                v-else-if="showBookNowForm && selectedObject && selectedObject._id"
                :object="selectedObject"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
    <v-row
      v-if="!showBookNowForm"
      :style="(showingMobileFullImages ? 'display:none;' : '') + ' padding-bottom: 70px;'"
    >
      <PageFooter class="d-none" />
    </v-row>
  </v-container>
</template>

<script>
import ObjectInfo from '@/components/Object/ObjectInfo'
import MyLoader from '@/components/App/_MyLoader'
import BookingForm from '@/components/Forms/BookingForm'
import SearchForm from '@/components/Forms/SearchForm'
import ObjectImagesFullMobile from '@/components/ObjectImages/ObjectImagesFullMobile'
import ObjectPageHeaderMobile from '@/components/App/Header/ObjectPageHeaderMobile'
import sharedComputed from '@/methods/sharedComputed'
import MobileLeftMenu from '@/components/App/Menu/MobileLeftMenu'
import MobileRightMenu from '@/components/App/Menu/MobileRightMenu'
import { createHelpers } from 'vuex-map-fields'
import state from '@/store/state'
import MobileTopPart from '@/components/Views/Layout/MobileTopPart'
import PageFooter from '@/components/App/_PageFooter'

const { mapFields } = createHelpers({
  getterType: 'getField',
  mutationType: 'updateField'
})

export default {
  name: 'ObjectPageMobile',

  components: {
    PageFooter,
    MobileTopPart,
    MobileRightMenu,
    MobileLeftMenu,
    ObjectPageHeaderMobile,
    ObjectImagesFullMobile,
    SearchForm,
    BookingForm,
    MyLoader,
    ObjectInfo,
  },

  computed: {
    ...mapFields(Object.keys(state)),
    ...sharedComputed,

    showingMobileFullImages () {
      return this.isMobileView && this.showingFullImage && this.selectedObject?.objectImages.length > 0
    },
  },
}
</script>
